export default __webpack_public_path__ + "static/media/complementary--slippery-for-caravan-trailers--g1.22bf4483.png";